<template>
  <span
    :class="[
      'badge',
      'text-white',
      statuses[order.operation_id][order.status].class,
    ]"
    style="line-height: 1.2"
  >
    {{ statuses[order.operation_id][order.status].text }}
    {{ order.number }}</span
  >
</template>

<script>

import orderStatus from "@/mixins/order/OrderStatus"

export default {
  mixins : [ orderStatus ],
  
  props: {
    order: {},
  },
};
</script>

<style>
</style>